import { SelectHotelsUser } from 'app/components'
import { useAppMainHotelSelector } from './@hooks'
import { COMPETITION_URL, FEATURES } from 'app/@common/constants'
import React, {useState} from 'react'
import { useTranslation } from 'react-i18next'

const ALL_HOTELS_MODE_KEY = 'packagesAllHotelsMode'

export default function AppHeaderMainHotel({ feature, url= COMPETITION_URL.MAIN_HOTELS }) {

    const { t } = useTranslation('common')
    const ALL_HOTELS_OPTION = { value: null, label: t('hotels.all') }
    const { onChange, onInit, updateMainHotels, idMainHotel, isMultiHotel, mainHotels, mainHotelsLabel, selectedMainHotel, isUserMaster, isChangingHotel } = useAppMainHotelSelector(feature)
    const [totalOptions, setTotalOptions] = useState(0)
    if (!isMultiHotel) return null

    const isPackages = feature === FEATURES.PACKAGES

    return <div className={`select-hotels-header ${!isUserMaster ? 'no-master' : ''}`}>
        <SelectHotelsUser
            value={mainHotels}
            onChange={({ value, label }) => {
                onChange(value, label)
            }}
            isDisabled={isChangingHotel}
            fallbackLabel={mainHotelsLabel}
            placeholder={t('hotels.allMain')}
            reload={true}
            label=""
            urlAjax={url}
            onAjax={(options = []) => {
                // "All hotels" mode only exists in Packages — ignore the flag elsewhere.
                const isAllMode = isPackages && localStorage.getItem(ALL_HOTELS_MODE_KEY) === 'true'
                if (isAllMode) {
                    updateMainHotels({ mainHotels: null })
                } else {
                    onInit(parseInt(selectedMainHotel) || idMainHotel)
                }
                const enrichedOptions = isPackages ? [ALL_HOTELS_OPTION, ...options] : options
                setTotalOptions(enrichedOptions?.length)
                return enrichedOptions
            }}
            totalOptions={totalOptions}
        />
    </div>
}